module.exports = __webpack_public_path__ + "static/media/4-mobile.60847961.webp";